import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

export class Utils {
   
  static corelids: any = {"REBAL":"","OPTANL":"","SAVEORDER":"","FREETRADE":""};
  public static calcdate(daydiff: number, sourcedt?: Date): Date {
    let retDt = new Date();
    if (sourcedt) {
      retDt = sourcedt;
    }
    if (daydiff) {
      retDt.setDate(retDt.getDate() - daydiff);
    }
    return retDt;
  }

  public static getAnyArray(i:any):any[]{
    return i as any[];
  }

  public static applyOrderBy(data: any, orderBy: string, field: string, isNumber = false): any {
    let tempPositions = JSON.parse(JSON.stringify(data));
    tempPositions.sort((p1:any, p2:any) => {
      const _p1 = p1[field] ? p1[field] : 0;
      const _p2 = p2[field] ? p2[field] : 0;
      if (isNumber) {
        if (orderBy === "ASC") {
          return parseFloat(_p2) - parseFloat(_p1);
        }
        else {
          return parseFloat(_p1) - parseFloat(_p2);
        }
      }
      if (orderBy === "ASC") {
        if (_p1 > _p2) {
          return 1;
        }
        if (_p1 < _p2) {
          return -1;
        }
        return 0;
      } else {
        if (_p1 > _p2) {
          return -1;
        }
        if (_p1 < _p2) {
          return 1;
        }

        return 0;
      }
    });
    return tempPositions;
  }

  public static getHttpOptions(corelationfrom:string = "", corelatedto:string = "") {
    const JWT = 'Bearer ' + sessionStorage.getItem('msal.idtoken');
    const httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin':'*',
        'content-type': 'application/json',
        'Cache-Control': 'no-cache',
        'RCM-PM-GUID':this.newGuid(corelationfrom, corelatedto),
        //'Authorization': JWT,
      })
    };    
    return httpOptions;
  }

  public static getHttpOptionsformdata(corelationfrom:string = "",corelatedto:string = "") {
    const JWT = 'Bearer ' + sessionStorage.getItem('msal.idtoken');
    const httpOptions = {
      headers: new HttpHeaders({        
        'Access-Control-Allow-Origin':'*',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache',
        'RCM-PM-GUID':this.newGuid(corelationfrom, corelatedto),
        //'Authorization': JWT,
      })
    };    
    return httpOptions;
  }

  public static newGuid(corelationfrom:string = "",corelatedto:string = "", ) {
    if(corelatedto && this.corelids[corelatedto]){
      return this.corelids[corelatedto]
    }
    const _guid =  'PMUI-' + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    if(corelationfrom){
      this.corelids[corelationfrom] = _guid;
    }
    return _guid;
  }

  public static readonly OPEN_FIELD_MAP: { [key: string]: string } = {
    'Open 0-7 Days': 'open0to7',
    'Open 8-20 Days': 'open8to20',
    'Open 21-45 Days': 'open21to45',
    'Open 46-60 Days': 'open46to60',
    'Open 61-75 Days': 'open61to75',
    'Open 76+ Days': 'open76plus'
  };

  public static zeroAsDash(value: number | string | null | undefined): number | string {
    if (value === 0) return '--';
    return value ?? '--';
  }

  public static getOpenCount(item: any, desc: string): number | string {
    const field = Utils.OPEN_FIELD_MAP[desc];
    if (!field) return '-';
    const val = item[field] ?? item[field.toLowerCase()];
    if (val === undefined || val === null) return '-';
    return val === 0 ? '--' : val;
  }

  public static getAlertColor(
    alertColorMap: { [groupCode: string]: { [alertDesc: string]: string } },
    rptType: string,
    desc: string,
    count?: number | string
  ): string {
    if (count !== undefined && (typeof count !== 'number' || count <= 0)) return '';
    const rptMap = alertColorMap[rptType];
    return rptMap ? (rptMap[desc] || '') : '';
  }

  public static goToSupervisionReport(
    router: Router,
    rptType: string,
    year: number,
    month: number,
    event: Event,
    alertDescription?: string,
    reportRole?: string,
    reportTypes?: { key: string; value: string }[]
  ): void {
    event.preventDefault();
    event.stopPropagation();
    router.navigate(['/report'], { state: { rptType, year, month, alertDescription, reportRole, reportTypes } });
  }

  public static titleCase(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
}
